export default __webpack_public_path__ + "1b293b533c04a5a91fffa6b031235de4.svg";